export default function closest(element, selector) {
    let node = element;

    while (node) {
        if (node.matches(selector)) {
            return !!node;
        } else {
            node = node.parentElement;
        }
    }
    return false;
}